<template>
	<div>
		<div class="card ml-1 mr-1 generic-card" style="margin-bottom:15px" >
			<div class="card-title" style="padding: 10px 15px;border-bottom: 1px solid #eee;">
				<div class="row">
					<div class="col-xs-6 text-left">
						<slot name="move"></slot>
					</div>
					<div class="col-xs-6 text-right">
						<a href="javascript:void(0);" @click="onGenericChange(generic)">
							<span class="glyphicon " :class="{'glyphicon-eye-open' : !generic.enable, 'glyphicon-eye-close' : generic.enable}"></span>
						</a>
					</div>
				</div>
			</div>
			<div class="card-img" :class="{ disable: !generic.enable }">
				<uploadfile v-model="generic.image_url" :height="156"></uploadfile>
			</div>
			
			<div class="card-body" :class="{ disable: !generic.enable }">
				<h4 class="card-title" style="font-weight: 600">
					<textarea name="title" id="title" style="width: 100%;resize: none;height: 50px;" class="form-control" v-model="generic.title" placeholder="Type here" @change="$emit('input',generic)"></textarea>
				
				</h4>

				<p class="card-text">
					<textarea name="subtitle" id="subtitle" style="width: 100%;resize: none;height: 100px;" class="form-control" v-model="generic.subtitle" placeholder="Type here" @change="$emit('input',generic)"></textarea>
					
				</p>
			</div>
			<ul class="list-group list-group-flush"  style="margin-bottom: 0px;" :class="{ disable: !generic.enable }">
			    <template v-if="generic.buttons.length > 0">
					<li class="list-group-item" style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center" v-for="(button,bindex) in generic.buttons" :key="bindex"><span>{{ button.title }} <add-generic-button v-model="generic.buttons[bindex]" @onSave="editButton(bindex, $event)"><span class="glyphicon glyphicon-pencil"></span></add-generic-button> <a href="javascript:void(0);" @click="deleteButton(bindex)" style="margin-left: 10px;"><span class="glyphicon glyphicon-remove"></span></a></span> </li>
				</template>
				<li v-if="generic.buttons.length < 3" class="list-group-item" style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center" ><add-generic-button v-model="newButton" @onSave="addNewButton"><span class="glyphicon glyphicon-plus"></span> Add button</add-generic-button></li>
			</ul>
		</div>
		
	</div>
</template>

<style>
	.generic-card .disable{
		opacity: 0.40; 
	}
</style>

<script>
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'

import AddGenericButton from '@/components/view/chatbot/AddGenericButton'

export default{
	components: {
		specialtext,
		uploadfile,
		AddGenericButton
	},
	props: ['value'],
	data: function() {
		return {
			generic : this.value,
			showModal : false,
			newButton: {
				title: '',
				type: 'web_url',
				url: ''
			}
		}
	},
	methods: {
		onSave: function(){
			this.$emit('onSave',this.generic)
		},
		onGenericChange: function(generic){
			generic.enable = !generic.enable
		},
		addNewButton: function(payload){
			if (this.generic.buttons.length < 3) {
				this.generic.buttons.push(payload)
				this.newButton = {
					title: '',
					type: 'web_url',
					url: ''
				}
			}

		},
		editButton: function(index, payload){
			if (this.generic.buttons[index]) {
				// this.generic.buttons[index] = payload
				this.$set(this.generic.buttons, index , payload)
			}
		},
		deleteButton: function(index){
			this.generic.buttons.splice(index,1)
		}
	},
	watch: {
		value: function(){
			this.generic = this.value
		},
		'generic' : function(newVal, oldVal){
			// this.$emit('onSave')
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/setting/WelcomeMessageGeneric.vue